import React, { useCallback, useEffect, useState } from 'react';
import { sleep } from '../../utils/helpers';
import './shareLink.scss';

interface ShareLinkProps {
  url: string;
  width?: string;
  active?: boolean;
}
const ShareLink = (props: ShareLinkProps) => {

  const { url } = props;

  const [copied, setCopied] = useState(false);

  const handleCopy = async (ev) => {
    if (ev) {
      ev.stopPropagation();
    }
    if (props.active) {
      navigator.clipboard.writeText(url);
      setCopied(true);
      await sleep(3000);
      setCopied(false);
    }
  };

  const handleInputClick = (e) => {
    e.target.setSelectionRange(0, e.target.value.length);
  };

  return <div className="share-link-container" style={{ width: props.width }}>
    <input className="link-text" value={url} readOnly={true} onClick={(e) => handleInputClick(e)} />
    <div className={"link-rectangle " + (props.active ? '' : 'disabled' )}>
      {copied ?
        <div className="link-copied">Copied</div>
        :
        <div className="link-copy" onClick={(e) => handleCopy(e)}>Copy</div>
      }
    </div>
  </div>
}

export default ShareLink;
